import { useEffect, useState } from "react"
import { Layout } from "components/common"
import BoxRelatedToChanel from "components/BoxRelatedToChanel"
import { apiChannel } from "api"
import config from "lib/config"
import fetchWithTimeout from "api/fetchWithTimeout"
import ViewPlay from "components/ViewPlay"
import Image from "next/legacy/image"
import cn from "classnames"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useRef } from "react"
import { trackGA } from "lib/func"
import { detectDRMPlatform } from "utils/helper"
import IconStar from "assets/icon/iconStar"

const Share = dynamic(() => import("components/Share"), { ssr: false })

export default function Channel({ query, initVideo }) {
  const router = useRouter()
  const [videoPlay, setVideoPlay] = useState(initVideo)
  const [channels, setChanel] = useState([])
  const [topics, setTopics] = useState([])
  const [topicId, setTopicId] = useState()
  const [scheduleList, setScheduleList] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0])
  const __init = useRef(initVideo)

  async function getChannels(topic_id) {
    try {
      const { data } = await apiChannel.getChannels({ event_id: query?.id, topic_id })
      setChanel(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function getBroadcastSchedule(date, eventId) {
    try {
      const drmType = detectDRMPlatform(typeof navigator !== "undefined" ? navigator.userAgent : "")
      const params = {
        event_id: eventId || query?.id,
        date: date || selectedDate,
        platform: drmType,
        version: "1.2.3"
      }
      const { data } = await apiChannel.getBroadcast(params)
      setScheduleList(data || [])
    } catch (error) {
      console.log(error)
      setScheduleList([])
    }
  }
  async function getTopics() {
    try {
      const { data } = await apiChannel.getTopics()
      // setTopics([{ id: undefined, name: "Tất cả" }, ...data])
      setTopics(data)
      if (data?.length > 0) {
        const firstTopicId = data[0].id
        setTopicId(firstTopicId)
        getChannels(firstTopicId)
      }
    } catch (error) {
      console.log(error)
    }
  }
  function onChangeTopic(v) {
    setTopicId(v)
    getChannels(v)
  }

  function onChangePlay(v) {
    if (v && initVideo?.id && v?.url) {
      // console.log({ v })
      setVideoPlay(v)
    } else {
      setVideoPlay(__init.current)
    }
  }

  function handleDateChange(date) {
    setSelectedDate(date)
    getBroadcastSchedule(date, query?.id)
  }

  function handleChannelChange(channelId) {
    router.push(`/channel?id=${channelId}`)
  }

  useEffect(() => {
    getChannels()
    getTopics()
    getBroadcastSchedule()
  }, [])

  useEffect(() => {
    if (query?.id) {
      getBroadcastSchedule(selectedDate, query?.id)
    }
  }, [query?.id])

  useEffect(() => {
    async function fetchVideoById() {
      const drmType = detectDRMPlatform(typeof navigator !== "undefined" ? navigator.userAgent : "")
      console.log("drmType===", drmType)
      if (!router.query.id) return
      try {
        const params = { ...router.query, platform: drmType, type: 1 }
        const response = await fetchWithTimeout(`${config.BASE_API_URL}/publish/event/?` + new URLSearchParams(params))
        const res = await response.json()
        if (response.ok && res?.data) {
          setVideoPlay(res.data)
          __init.current = res.data
          trackGA(res.data?.name, "CHANNEL_VIDEO")
          trackGA(res.data?.name, "ChannelDetailVC")
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchVideoById()
  }, [router.query.id])

  useEffect(() => {
    __init.current = {
      ...initVideo,
      channel: {
        name: initVideo?.name
      }
    }
    trackGA(initVideo?.name, "CHANNEL_VIDEO")
    trackGA(initVideo?.name, "ChannelDetailVC")
  }, [initVideo])

  const { title, descriptions, synopsis, name } = videoPlay

  return (
    <section className="mb-16 min-[1200px]:pr-8 min-[1200px]:pl-0 px-4">
      <div className="lg:grid grid-cols-3 xl:grid-cols-10 gap-4 mb-5">
        <div className="col-span-2 xl:col-span-7 mb-4">
          <ViewPlay initVideo={videoPlay} />
          <div className="lg:text-xl mt-4 mb-3 text-[#fafaf9] font-semibold text-lg">{name}</div>
          <div className="flex justify-between items-center gap-4">
            <div className="md:text-base text-secondary text-sm">{descriptions}</div>

            <Share initVideo={videoPlay} />
          </div>
        </div>
        <div className="grid-cols-1 xl:col-span-3">
          <BoxRelatedToChanel
            list={scheduleList}
            event_id={query?.id}
            onChangePlay={onChangePlay}
            onDateChange={handleDateChange}
          />
        </div>
      </div>
      <div className="flex flex-col gap-3.5">
        <div className="font-semibold text-2xl">Danh sách kênh</div>
        {topics?.length > 0 && (
          <div className="flex gap-3">
            {topics?.map(({ id, name }, k) => {
              const __class =
                topicId === id
                  ? "bg-[#2E2E2E] border border-[#3a3a3a] text-[#fafaf9]"
                  : "bg-transperant border border-[#131313]"
              return (
                <button
                  key={k}
                  className={cn("px-7 py-3 text-sm rounded-xl font-medium hover:bg-[#2f2f2f]", __class)}
                  onClick={() => onChangeTopic(id)}
                >
                  {name}
                </button>
              )
            })}
          </div>
        )}

        <div className="gap-5 grid md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 grid-cols-2">
          {channels?.map(({ thumbnail, id, is_premium, name, package_type }) => {
            const __class = query?.id === id ? "border-blue-400 rounded-2xl" : "border-transparent rounded-2xl"
            return (
              <div key={id} className="col-span-1" onClick={() => handleChannelChange(id)}>
                <CardChannel
                  __class={__class}
                  is_premium={is_premium}
                  thumbnail={thumbnail}
                  name={name}
                  package_type={package_type}
                  isPlaying={videoPlay?.id === id}
                />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

Channel.Layout = Layout

function CardChannel({ __class, thumbnail, name, package_type, isPlaying, is_premium }) {
  const [srcImage, setSrcImage] = useState(thumbnail)
  return (
    <>
      <div className={cn("cursor-pointer relative", __class)}>
        <div className="fix_img">
          <Image
            width={486}
            height={274}
            className="rounded-xl object-cover"
            src={srcImage}
            onError={() => setSrcImage("https://stvinaprod.vtvcab.vn/4ab5f0e3-d616-4834-9485-d54b0ebb7115.png")}
          />
        </div>
        {is_premium && (
          <div className="flex items-center gap-1 absolute top-3 left-0 bg-[linear-gradient(to_right,#FF4D00,#F67A36)] py-1 px-2">
            <IconStar />
            <span className="text-[#FFEB99] text-xs font-bold">Premium</span>
          </div>
        )}
        {isPlaying && (
          <div className="absolute flex gap-1.5 right-2 bottom-2.5 py-0.5 px-1.5 text-sm text-[#f4f4f8] rounded bg-[#13131385]">
            <img src="/icons/iconSignal.svg"></img> Đang phát
          </div>
        )}
      </div>
      {/* <div className="line-clamp-1 text-sm mt-2 bottom-0 left-0 w-full text-dark-100">{name}</div> */}
    </>
  )
}

export async function getServerSideProps({ req, query }) {
  let initVideo = {},
    error = {}
  const userAgent = req.headers["user-agent"] || ""
  const drmType = detectDRMPlatform(userAgent)
  try {
    const params = { ...query, platform: drmType, type: 1 }
    const response = await fetchWithTimeout(`${config.BASE_API_URL}/publish/event/?` + new URLSearchParams(params))
    const res = await response?.json()
    if (response?.ok) {
      if (res?.data) initVideo = res?.data
    } else {
      error = res
      // error.error_code = 412
      console.log("API - Get channel or channel: ", res)
    }
  } catch (error) {
    console.log(error)
  }
  if (error?.error_code) initVideo.error = error
  return { props: { initVideo, query, error } }
}
